import { useQuery } from "@tanstack/react-query";
import { fetchPublicDashboard } from "../../../services/b2b-reporting-apiServices";
import useObfuscateDashboardId from "./useObfuscateDashboardId";
import useDecryptData from "../../b2b-common/hooks/useDecryptData";

const useGettingPublicDashboard = (obfuscatedDashboardId, password = null) => {

    const { decode } = useObfuscateDashboardId();
    const { decryptData } = useDecryptData();
    const seed = 18082050;
    const { organizationUUID, dashboardId } = decode(obfuscatedDashboardId, seed) || {};

    const getPublicDashboard = async () => {
        const response = await fetchPublicDashboard(organizationUUID, dashboardId, password);
        return decryptData(response);
    }

    const { data: publicDashboard, error, isLoading } = useQuery({
        queryKey: ['fetchPublicDashboard', obfuscatedDashboardId],
        queryFn: getPublicDashboard,
        enabled: !!obfuscatedDashboardId,
        cacheTime: 0, //15 * 60 * 1000,
    });

    return { publicDashboard, error, isLoading };
}

export default useGettingPublicDashboard;        